// Simple Telugu / English i18n for the public registration form
import { createContext, useContext, useMemo, useState } from "react";

const STR = {
  en: {
    "form.title": "Youth Registration",
    "form.cancel": "Cancel",
    "step.personal": "Personal",
    "step.education": "Education",
    "step.interests": "Interests",
    "step.career": "Career",
    "step.bank": "Bank & Submit",
    "personal.heading": "Personal Details",
    "field.full_name": "Full Name *",
    "field.full_name.placeholder": "As per Aadhaar",
    "field.aadhaar": "Aadhaar Number *",
    "field.aadhaar.placeholder": "12-digit",
    "field.gender": "Gender *",
    "gender.male": "Male", "gender.female": "Female", "gender.other": "Other",
    "field.dob": "Date of Birth *",
    "field.mobile": "Mobile Number *",
    "field.mobile.placeholder": "10-digit",
    "field.email": "Email (optional)",
    "field.village": "Village *",
    "field.village.placeholder": "Select village",
    "field.pincode": "Pincode",
    "field.address": "Address",
    "education.heading": "Education & Qualification",
    "field.education_level": "Highest Education *",
    "field.education_status": "Status *",
    "field.qualification": "Qualification details (institution, year, marks)",
    "field.qualification.placeholder": "e.g. B.Tech CSE, JNTU Kakinada, 2023, 72%",
    "field.skills": "Skills you already know",
    "field.languages": "Languages known",
    "interests.heading": "Interested Domains",
    "interests.subtitle": "Select areas you'd like to upskill in.",
    "interests.ai_track": "I'm interested in AI Upskilling track",
    "interests.ai_track_sub": "Free AI/ML training designed for rural youth via RTIH.",
    "career.heading": "Career Preferences",
    "field.employment_status": "Current Employment Status *",
    "field.placement_pref": "What are you looking for? *",
    "pref.job": "Job/Placement", "pref.job.desc": "Find employment",
    "pref.self": "Self-employment", "pref.self.desc": "Start a business",
    "pref.both": "Both", "pref.both.desc": "Open to either",
    "field.job_type": "Job type preference",
    "field.income": "Family monthly income (₹)",
    "bank.heading": "Self-Employment & Bank Linkage",
    "field.startup_idea": "Do you have a startup / business idea?",
    "field.startup_idea.placeholder": "Briefly describe your idea (optional)",
    "field.bank_linkage": "I need bank loan / linkage support (MUDRA / PMEGP / NRLM)",
    "field.bank_linkage.sub": "RTIH will guide you through documents and approvals.",
    "field.loan_amount": "Estimated loan amount (₹)",
    "review.heading": "Review summary",
    "btn.back": "Back", "btn.next": "Next", "btn.submit": "Submit Registration",
    "btn.submitting": "Submitting…",
    "aadhaar.verify": "Verify",
    "aadhaar.verified": "Aadhaar verified",
    "aadhaar.invalid": "Invalid Aadhaar (checksum failed)",
    "otp.label": "Enter 6-digit OTP",
    "otp.verify": "Confirm OTP",
    "common.optional": "Optional",
    "common.select": "Select",
  },
  te: {
    "form.title": "యువత నమోదు",
    "form.cancel": "రద్దు చేయి",
    "step.personal": "వ్యక్తిగత",
    "step.education": "విద్య",
    "step.interests": "ఆసక్తులు",
    "step.career": "వృత్తి",
    "step.bank": "బ్యాంక్ & సమర్పించండి",
    "personal.heading": "వ్యక్తిగత వివరాలు",
    "field.full_name": "పూర్తి పేరు *",
    "field.full_name.placeholder": "ఆధార్ ప్రకారం",
    "field.aadhaar": "ఆధార్ నంబర్ *",
    "field.aadhaar.placeholder": "12-అంకెల",
    "field.gender": "లింగం *",
    "gender.male": "పురుషుడు", "gender.female": "స్త్రీ", "gender.other": "ఇతర",
    "field.dob": "పుట్టిన తేదీ *",
    "field.mobile": "మొబైల్ నంబర్ *",
    "field.mobile.placeholder": "10-అంకెల",
    "field.email": "ఇమెయిల్ (ఐచ్ఛికం)",
    "field.village": "గ్రామం *",
    "field.village.placeholder": "గ్రామాన్ని ఎంచుకోండి",
    "field.pincode": "పిన్‌కోడ్",
    "field.address": "చిరునామా",
    "education.heading": "విద్య & అర్హత",
    "field.education_level": "ఉన్నత విద్య *",
    "field.education_status": "స్థితి *",
    "field.qualification": "అర్హత వివరాలు (సంస్థ, సంవత్సరం, మార్కులు)",
    "field.qualification.placeholder": "ఉదా. B.Tech CSE, JNTU Kakinada, 2023, 72%",
    "field.skills": "మీకు తెలిసిన నైపుణ్యాలు",
    "field.languages": "తెలిసిన భాషలు",
    "interests.heading": "ఆసక్తి ఉన్న రంగాలు",
    "interests.subtitle": "మీరు నైపుణ్యం పెంచుకోదలచిన రంగాలను ఎంచుకోండి.",
    "interests.ai_track": "నేను AI అప్‌స్కిల్ ట్రాక్‌లో ఆసక్తి కలిగి ఉన్నాను",
    "interests.ai_track_sub": "RTIH ద్వారా గ్రామీణ యువత కోసం ఉచిత AI/ML శిక్షణ.",
    "career.heading": "వృత్తి ప్రాధాన్యతలు",
    "field.employment_status": "ప్రస్తుత ఉపాధి స్థితి *",
    "field.placement_pref": "మీరు దేని కోసం వెతుకుతున్నారు? *",
    "pref.job": "ఉద్యోగం/నియామకం", "pref.job.desc": "ఉద్యోగాన్ని కనుగొనండి",
    "pref.self": "స్వయం-ఉపాధి", "pref.self.desc": "వ్యాపారాన్ని ప్రారంభించండి",
    "pref.both": "రెండూ", "pref.both.desc": "ఏదైనా ఆమోదయోగ్యం",
    "field.job_type": "ఉద్యోగ రకం ప్రాధాన్యత",
    "field.income": "కుటుంబ నెలవారీ ఆదాయం (₹)",
    "bank.heading": "స్వయం-ఉపాధి & బ్యాంక్ లింకేజ్",
    "field.startup_idea": "మీకు స్టార్టప్ / వ్యాపార ఆలోచన ఉందా?",
    "field.startup_idea.placeholder": "మీ ఆలోచనను సంక్షిప్తంగా వివరించండి (ఐచ్ఛికం)",
    "field.bank_linkage": "నాకు బ్యాంక్ రుణం / లింకేజ్ మద్దతు అవసరం (MUDRA / PMEGP / NRLM)",
    "field.bank_linkage.sub": "RTIH మీకు పత్రాలు మరియు ఆమోదాలతో మార్గనిర్దేశం చేస్తుంది.",
    "field.loan_amount": "అంచనా రుణ మొత్తం (₹)",
    "review.heading": "సమీక్ష సారాంశం",
    "btn.back": "వెనుకకు", "btn.next": "తదుపరి", "btn.submit": "నమోదు సమర్పించండి",
    "btn.submitting": "సమర్పిస్తోంది…",
    "aadhaar.verify": "ధృవీకరించండి",
    "aadhaar.verified": "ఆధార్ ధృవీకరించబడింది",
    "aadhaar.invalid": "చెల్లని ఆధార్ (చెక్‌సమ్ విఫలమైంది)",
    "otp.label": "6-అంకెల OTP నమోదు చేయండి",
    "otp.verify": "OTP ధృవీకరించండి",
    "common.optional": "ఐచ్ఛికం",
    "common.select": "ఎంచుకోండి",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("psi_lang") || "en");
  const setLangPersist = (l) => {
    localStorage.setItem("psi_lang", l);
    setLang(l);
  };
  const t = (key) => STR[lang]?.[key] ?? STR.en[key] ?? key;
  const value = useMemo(() => ({ lang, setLang: setLangPersist, t }), [lang]);
  return (
    <I18nContext.Provider value={value}>
      {children}
    </I18nContext.Provider>
  );
}

export const useI18n = () => useContext(I18nContext);
